import React from 'react'
import Paper from '@modul-connect/shared/components/atoms/paper'
import Page from '@modul-connect/shared/components/atoms/page.v2'
import { P } from '@modul-connect/shared/components/atoms/text'
import View from '@modul-connect/shared/components/atoms/view'

export const EmptyState = ({ title, textRow, textRow2 }) => {
  return (
    <Page>
      <Paper title={title} extendChildContainer={{ alignItems: 'flex-start' }}>
        <View>
          <P>{textRow}</P>
          <P>{textRow2}</P>
        </View>
      </Paper>
    </Page>
    
  )
}